import type { NavigationMenuLinkProps } from '@radix-ui/react-navigation-menu'
import type { PropsWithChildren } from 'react'
import * as NavigationMenu from '@radix-ui/react-navigation-menu'
import TopNavigationBarItem from '@/scopes/common/components/Header/TopNavigationBarItem'
import { withTypographyClassName } from '@/scopes/common/components/Header/typography'
import styles from './HeaderLink.module.css'

export function HeaderLink({ children, className, ...rest }: PropsWithChildren<NavigationMenuLinkProps> & { className?: string }) {
  return (
    <NavigationMenu.Link asChild {...rest}>
      <TopNavigationBarItem as="a" className={className}>
        {withTypographyClassName(children, styles.boldText)}
      </TopNavigationBarItem>
    </NavigationMenu.Link>
  )
}
